
import { ConfigProvider, App as AppAnt, Spin } from 'antd';
import 'antd/dist/reset.css';
import { Provider } from 'jotai';
import Footer from 'components/layout/V2/Footer';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import Org from 'pages/Organization/Org';
import OrganizationChartPage from 'pages/Organization/Chart';
import ManageOrg from 'pages/Organization/Org/ManageOrg';

import Department from 'pages/Organization/Department/index';
import ManageDepartment from 'pages/Organization/Department/ManageDepartment';

import Division from 'pages/Organization/Division';
import ManageDivision from 'pages/Organization/Division/ManageDivision';

import Position from 'pages/Organization/Position';
import ManagePosition from 'pages/Organization/Position/ManagePosition';

import Role from 'pages/UserManagement/Role';
import ManageRole from 'pages/UserManagement/Role/ManageRole';

import User from 'pages/UserManagement/User';
import ManageUser from 'pages/UserManagement/User/ManageUser';

import WorkingCal from 'pages/MasterData/WorkingCalendar';
import ManageWorkingCalendar from 'pages/MasterData/WorkingCalendar/ManageWorkingCalendar';


import Task from 'pages/Task/TaskList';
import Resource from 'pages/Resources/Resources';


// import WBS from 'pages/WBS/WBS';
import ManageWBS from 'pages/WBS/ManageWbs';


import OrganizationReport from 'pages/Report/Organization/OrganizationReport';
import DivisionReport from 'pages/Report/Division/DivisionReport';
import DepartmentReport from 'pages/Report/Department/DepartmentReport';
import PositionReport from 'pages/Report/Position/PositionReport';
import WbsReport from 'pages/Report/WBS/WbsReport';
import WbsDetailReport from 'pages/Report/WBS/WbsDetailReport';

import Login from 'pages/Auth';
import Register from 'pages/Auth/Register';
import OidcCallback from 'pages/Auth/OidcCallback';
import Constant from 'utils/Constants';
import { APP_ROUTE_PREFIX, RouteConstant } from './routesConstant';
import { useEffect, useState } from 'react';
import jwtDecode from "jwt-decode";
import LocalStorageUtils from 'utils/LocalStorage';
import CustomAlert from 'utils/CustomAlert';
import Swal from "sweetalert2"
import useAuthRepo from 'services/repo/useAuthRepo';
import { dismissToast, errorToast, loadingToastId } from 'utils/Toast';
// import { dateGreaterThan } from 'utils/Helper';
import LeftSidebar from 'components/layout/V2/LeftSidebar';
import Topbar from 'components/layout/V2/Topbar';

// import Dashboard from 'pages/Dashboard';

import MyProfile from 'pages/MyProfile';
import AntConfig from 'utils/AntConfig';
import ResetPassword from 'pages/Auth/ResetPassword';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
import ForgetPassword from 'pages/Auth/ForgetPassword';
import OnboardingEntry from 'pages/Onboarding';
import AccountActivationPage from 'pages/Onboarding/AccountActivationPage';
import SubscriptionWelcomePage from 'pages/Onboarding/FirstLoginWelcomePage';
import GetStartedPage from 'pages/Onboarding/GetStartedPage';
import TenantManagement from 'pages/TenantManagement';
import InvitationPage from 'pages/Invitation';
import DemoScenariosPage from 'pages/DemoScenarios';

import Dashboard from 'pages/Dashboard/index';
import WorkspaceSetupPage from 'pages/Onboarding/WorkspaceSetupPage';
import CommercialFlowPage from 'pages/Subscription/CommercialFlowPage';
import SessionStorageUtils from 'utils/SessionStorage';
import { validateSelectedTenant } from 'services/tenant/tenantMembershipService';
import { resolvePostLoginDestination } from 'services/auth/postLoginRoute';
import Wbs from 'pages/WBS';
import ManageTaskSubmission from 'pages/WBS/ManageTaskSubmission';
import ManageTaskApproval from 'pages/WBS/ManageTaskApproval';
import ManageTaskReview from 'pages/WBS/ManageTaskReview';

// Temporary UI-demo setting. Disable the refresh-token warning dialog and
// automatic expiry prompt while the business flow is being demonstrated.
const ENABLE_REFRESH_TOKEN_PROMPT = false;



export default function App() {

  const isMobile = useIsMobileHooks(Constant.mediaQuery.isLG)

  return (
    <ConfigProvider theme={AntConfig}>
      <div className={`eproc-master ${!isMobile ? 'sidebar-show' : ""}`}>
        <Provider>
          <BrowserRouter>
            <AppAnt>
              <Routes>
                <Route path='/' element={<Login />} />
                <Route path='/register' element={<Register />} />
                <Route path='/auth/oidc/callback' element={<OidcCallback />} />
                <Route path='/onboarding' element={<OnboardingEntry />} />
                <Route path='/activate-account' element={<AccountActivationPage />} />
                <Route path='/welcome' element={<SubscriptionWelcomePage />} />
                <Route path='/get-started' element={<GetStartedPage />} />
                <Route path='/invitation/:invitationId' element={<InvitationPage />} />
                <Route path='/demo-scenarios' element={<DemoScenariosPage />} />
                <Route path={`${APP_ROUTE_PREFIX}/${RouteConstant.tenantSelection}`} element={<TenantManagement />} />
                <Route path={"/" + RouteConstant.resetPassword} element={<ResetPassword />} />
                <Route path={"/" + RouteConstant.forgotPassword} element={<ForgetPassword />} />
                <Route path={`${APP_ROUTE_PREFIX}/*`} element={<Template />} />
              </Routes>
            </AppAnt>
          </BrowserRouter>
        </Provider>

      </div>
    </ConfigProvider>
  );
}

const Template = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const { isLoading: isLoadingRefreshToken, refreshToken } = useAuthRepo(false)
  const { logout } = useAuthRepo(false)
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [organizationContext, setOrganizationContext] = useState({ status: 'loading', organization: null });

  useEffect(() => {
    let cancelled = false;

    const prepareOrganizationContext = async () => {
      try {
        const { selectedTenant, memberships } = await validateSelectedTenant();
        if (cancelled) return;

        if (selectedTenant) {
          setOrganizationContext({ status: 'ready', organization: selectedTenant });
          return;
        }

        const destination = await resolvePostLoginDestination({ memberships });
        if (cancelled) return;
        const organization = memberships.length === 1 ? memberships[0] : null;
        setOrganizationContext({ status: organization ? 'ready' : 'redirecting', organization });
        navigate(destination, { replace: true });
      } catch {
        if (cancelled) return;
        setOrganizationContext({ status: 'redirecting', organization: null });
        navigate(`${APP_ROUTE_PREFIX}/${RouteConstant.tenantSelection}?mode=manage`, { replace: true });
      }
    };

    prepareOrganizationContext();
    return () => { cancelled = true; };
  }, [navigate]);

  useEffect(() => {
    if (!ENABLE_REFRESH_TOKEN_PROMPT) {
      setVisiblePopup(false);
      Swal.close();
    }
  }, []);

  const fetchRefreshToken = async () => {
    loadingToastId(Constant.message.loading, 1)
    let res = await refreshToken()
    dismissToast(1)
    if (res?.isValid && res?.statusCode === 200) {
      let token = res?.data?.bearerToken
      LocalStorageUtils.jwtToken.set(token)
      SessionStorageUtils.currentJwtToken.set(token)
    } else {
      errorToast("Error Refresh Token")
      logout()
    }
  }

  // CHECK EXPIRED TOKEN
  useEffect(() => {
    if (LocalStorageUtils.checkTokenExpired()) {
      //used for redirect to spesific page after login
      if (location.pathname && location.search) {
        let redirectTo = `${location.pathname}${location.search}`
        return navigate(`/?redirectTo=${redirectTo}`, { replace: true })
      }
      LocalStorageUtils.jwtToken.clear()
      SessionStorageUtils.all.clear()
      navigate('/', { replace: true })
    }
  }, [])

  // CHECK EXPIRED TOKEN BEFORE 5 MINUTES
  // CHECK SESSION STORAGE
  useEffect(() => {
    const intervalId = setInterval(() => {
      let localStorageJwt = LocalStorageUtils.jwtToken.get()
      let sessionStorageJwt = SessionStorageUtils.currentJwtToken.get()

      if (localStorageJwt !== "") {
        let decodedLocalStorageJwt = jwtDecode(localStorageJwt);

        if (!sessionStorageJwt) {
          SessionStorageUtils.currentJwtToken.set(localStorageJwt)
        } else {
          let decodedSessionStorageJwt = jwtDecode(sessionStorageJwt);
          //check session storage and local storage is not same
          if (sessionStorageJwt !== localStorageJwt) {
            let userIdSession = decodedSessionStorageJwt?.userId
            let userIdLocalStorage = decodedLocalStorageJwt?.userId
            if (userIdSession !== userIdLocalStorage) {
              SessionStorageUtils.all.clear()
              window.location.replace('/');
            } else {
              SessionStorageUtils.currentJwtToken.set(localStorageJwt)
            }
          }
        }

        const isTokenExpired = LocalStorageUtils.checkExpiredTokenBefore5Minutes()?.isExpired;
        const minute = LocalStorageUtils.checkExpiredTokenBefore5Minutes()?.minute;
        if (ENABLE_REFRESH_TOKEN_PROMPT && isTokenExpired) {
          if (!visiblePopup) setVisiblePopup(true)
          if (minute <= 0) {
            setVisiblePopup(false)
            Swal.close()
            logout()
          }
        }

      } else {
        window.location.replace('/');
        SessionStorageUtils.all.clear()
      }
    }, 2000);

    return () => {
      clearInterval(intervalId);
    };

  }, [])

  // MODAL CONFIRM REFRESH TOKEN
  useEffect(() => {
    if (ENABLE_REFRESH_TOKEN_PROMPT && visiblePopup && !isLoadingRefreshToken) {
      CustomAlert.confirm({
        title: "Token expired!",
        description: "Your token has expired. Would you like to extend it?",
        confirmButtonText: "Refresh Token",
        swalOptions: {
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false
        },
        onConfirmButton: () => {
          /*
          *Check the token again because if the user opens 2 or more tabs/windows, and in one tab/window has already performed a fetch to refresh the token and obtained a new token, then the other tabs/windows don't need to fetch a refresh token again.
          * */
          if (LocalStorageUtils.checkExpiredTokenBefore5Minutes()?.isExpired) {
            fetchRefreshToken()
          }
          setVisiblePopup(false)
        },
        onCancelButton: () => {
          if (LocalStorageUtils.checkExpiredTokenBefore5Minutes()?.isExpired) {
            logout()
          }
          setVisiblePopup(false)
        }
      })
    }
  }, [visiblePopup])


  useEffect(() => {
    const roleId = organizationContext.organization?.roleId;

    const BLOCKED_ROLE_IDS = [
      '4b03b020-194f-45a9-810a-06801ffa513c',
      '5febd304-7990-4ddd-a9ce-18812aae2a4f',
      '801e1d35-a9b5-4ef3-972d-c005cf503243'
    ];

    const isBlockedRole = BLOCKED_ROLE_IDS.includes(roleId);
    const currentPath = location.pathname;

    const isBlockedPath =
      currentPath === '/app/wbs-init/list' ||
      currentPath.startsWith('/app/wbs-init/edit/');

    if (isBlockedRole && isBlockedPath) {
      navigate('/app/dashboard', { replace: true });
    }
  }, [location.pathname, navigate, organizationContext.organization?.roleId]);

  if (organizationContext.status !== 'ready') {
    return <div className="dashboard-initial-check"><Spin size="large" tip="Preparing your organization context..." /></div>;
  }

  return (
    <>
      <div className='wrap-layout' >
        <LeftSidebar />
        <Topbar />
        <main className='eproc-main-container wrap-main-content'>
          <div className='eproc-content main-content-card'>
            <Routes>
              <Route path={"/" + RouteConstant.dashboard} element={<Dashboard />} />
              <Route path={"/" + RouteConstant.workspaceSetup} element={<WorkspaceSetupPage />} />
              <Route path="/subscription" element={<CommercialFlowPage />} />

              <Route path={"/" + RouteConstant.userManagement.role.index} element={<Role />} />
              <Route path={"/" + RouteConstant.userManagement.role.create} element={<ManageRole />} />
              <Route path={"/" + RouteConstant.userManagement.role.edit(":roleId")} element={<ManageRole />} />

              <Route path={"/" + RouteConstant.userManagement.user.index} element={<User />} />
              <Route path={"/" + RouteConstant.userManagement.user.create} element={<ManageUser />} />
              <Route path={"/" + RouteConstant.userManagement.user.edit(":userId")} element={<ManageUser />} />

              <Route path={"/" + RouteConstant.organization.org.index} element={<Org />} />
              <Route path={"/" + RouteConstant.organization.chart} element={<OrganizationChartPage />} />
              <Route path={"/" + RouteConstant.organization.org.create} element={<ManageOrg />} />
              <Route path={"/" + RouteConstant.organization.org.edit(":orgId")} element={<ManageOrg />} />

              <Route path={"/" + RouteConstant.organization.department.index} element={<Department />} />
              <Route path={"/" + RouteConstant.organization.department.create} element={<ManageDepartment />} />
              <Route path={"/" + RouteConstant.organization.department.edit(":deptId")} element={<ManageDepartment />} />

              <Route path={"/" + RouteConstant.organization.division.index} element={<Division />} />
              <Route path={"/" + RouteConstant.organization.division.create} element={<ManageDivision />} />
              <Route path={"/" + RouteConstant.organization.division.edit(":divId")} element={<ManageDivision />} />

              <Route path={"/" + RouteConstant.organization.position.index} element={<Position />} />
              <Route path={"/" + RouteConstant.organization.position.create} element={<ManagePosition />} />
              <Route path={"/" + RouteConstant.organization.position.edit(":posId")} element={<ManagePosition />} />

              <Route path={"/" + RouteConstant.myProfile} element={<MyProfile />} />

              <Route path={"/" + RouteConstant.masterData.WorkingCalendar.index} element={<WorkingCal />} />
              <Route path={"/" + RouteConstant.masterData.WorkingCalendar.create} element={<ManageWorkingCalendar />} />
              <Route path={"/" + RouteConstant.masterData.WorkingCalendar.edit(":wcId")} element={<ManageWorkingCalendar />} />


              <Route path={"/" + RouteConstant.workBreakdownStructure.index} element={<Wbs />} />
              <Route path={"/" + (RouteConstant.workBreakdownStructure.create || "")} element={<ManageWBS />} />

              <Route path={"/" + RouteConstant.workBreakdownStructure.edit(":wbsId")} element={<ManageWBS />} />

              <Route path={"/" + RouteConstant.workBreakdownStructure.submission.view(":taskId")} element={<ManageTaskSubmission />} />
              <Route path={"/" + RouteConstant.workBreakdownStructure.review.view(":taskId")} element={<ManageTaskReview />} />
              <Route path={"/" + RouteConstant.workBreakdownStructure.approval.view(":taskId")} element={<ManageTaskApproval />} />



              <Route path={"/" + RouteConstant.task.index} element={<Task />} />
              <Route path={"/" + RouteConstant.resource.index} element={<Resource />} />


              <Route path={"/" + RouteConstant.report.reportOrganization} element={<OrganizationReport />} />
              <Route path={"/" + RouteConstant.report.reportDivision(":orgId")} element={<DivisionReport />} />
              <Route path={"/" + RouteConstant.report.reportDepartment(":orgId", ":divId")} element={<DepartmentReport />} />

              <Route path={"/" + RouteConstant.report.reportPosition(":orgId", ":divId", ":deptId")} element={<PositionReport />} />
              {/* <Route path={"/" + RouteConstant.report.reportDepartment(":divId")} element={<DepartmentReport />} /> */}
              {/* <Route path={"/" + RouteConstant.report.reportPosition(":posId")} element={<PositionReport />} /> */}
              {/* <Route path={"/" + RouteConstant.report.reportPosition} element={<PositionReport />} /> */}
              <Route path={"/" + RouteConstant.report.reportWbs} element={<WbsReport />} />
              <Route path={"/" + RouteConstant.report.reportWbsDetail(":wbsId")} element={<WbsDetailReport />} />




            </Routes>
          </div>
          <Footer />

        </main>
      </div>
    </>
  )
}
